// DTOs de notificaciones in-app del módulo de mantenimiento.
//
//   - GET  /api/mantenimiento/notificaciones?solo_no_leidas=&limit=
//   - POST /api/mantenimiento/notificaciones/leer
//
// Persisten en la tabla `notificaciones` (mig 067). El fan-out nace en la
// transacción del POST /api/registros: paro de categoría es_mantenimiento →
// una notificación por técnico programado en (fecha, turno) del registro
// (fallback: coordinadores de mantenimiento activos). El FE hace polling 30s;
// ids nuevos disparan toast con CTA a /mantenimiento/lineas.
import { z } from 'zod';
const boolQueryParam = (def) => z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .default(def)
    .transform((v) => v === true || v === 'true');
/** Tipos emitidos hoy; el schema deja pasar futuros (string) sin romper FE. */
export const tipoNotificacionMttoConocidoSchema = z.enum([
    'paro_registrado',
    'correccion_resuelta',
]);
export const notificacionMttoSchema = z.object({
    id: z.string().uuid(),
    tipo: z.string(),
    titulo: z.string(),
    cuerpo: z.string().nullable(),
    /** Entidad relacionada, ej. 'registro_paro' | 'validacion_paro'. */
    entidad: z.string().nullable(),
    entidad_id: z.string().uuid().nullable(),
    read_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }),
});
export const notificacionesMttoQuerySchema = z.object({
    solo_no_leidas: boolQueryParam(false),
    limit: z.coerce.number().int().min(1).max(100).default(30),
});
export const notificacionesMttoResponseSchema = z.object({
    items: notificacionMttoSchema.array(),
    no_leidas: z.number().int().min(0),
});
/** ids vacío/ausente = marcar TODAS las no leídas del usuario. */
export const notificacionesLeerInputSchema = z.object({
    ids: z.array(z.string().uuid()).optional(),
});
export const notificacionesLeerResponseSchema = z.object({
    marcadas: z.number().int().min(0),
});
//# sourceMappingURL=mantenimiento_notificaciones.js.map